import { useEffect, useState, useMemo } from 'react';
import { AppShell, ScrollArea } from '@mantine/core';
import { IconDownload, IconCodeDots, IconFilterEdit, IconCertificate, IconUser } from '@tabler/icons-react';
import classes from '../css/NavbarNested.module.css';
import { get } from './Request';
import { useUser } from './Context';
import { LinksGroup } from './NavbarLinksGroup';

const mockdata = [
  {
    label: 'Modèles',
    icon: IconCodeDots,
    initiallyOpened: true,
    links: [
      { label: 'Créer un modèle', link: '/createmodel' },
      { label: 'Voir un modèle', link: '/mymodel' }
    ]
  },
  {
    label: 'Attestations',
    icon: IconDownload,
    initiallyOpened: true,
    links: [
      { label: 'Créer une attestation', link: '/definedata' },
      { label: 'Récupérérer des attestations', link: '/retrievedata' }
    ]
  },
  {
    label: 'Documents',
    icon: IconFilterEdit,
    initiallyOpened: true,
    links: [
      { label: 'Gestion des documents', link: '/myattestations' },
      { label: 'Générer la signature numérique', link: '/filetohash' },
      { label: 'Vérifier un document', link: '/verifydocument' }
    ]
  }
];

export function Navbar({ setUserExist, setIsAdmin }) {
  const [userExistLocal, setUserExistLocal] = useState(false);
  const [isAdminLocal, setIsAdminLocal] = useState(false);
  const { refresh } = useUser();
  const user = useUser();

  useEffect(() => {
    const adminStatus = localStorage.getItem('isAdmin') === 'true';
    setIsAdminLocal(adminStatus);
    setIsAdmin(adminStatus);

    const handleStorageChange = (event) => {
      if (event.key === 'isAdmin') {
        const updated = event.newValue === 'true';
        setIsAdminLocal(updated);
        setIsAdmin(updated);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [setIsAdmin]);

  const handleCheckToken = async () => {
    const token = localStorage.getItem('userToken');
    if (token) {
      try {
        const response = await get('checkToken', null, token);
        setUserExistLocal(response.exists);
        setUserExist(response.exists);
      } catch (error) {
        console.error('Error checking token:', error);
        setUserExistLocal(false);
        setUserExist(false);
      }
    } else {
      setUserExistLocal(false);
      setUserExist(false);
    }
  };

  useEffect(() => {
    handleCheckToken();
  }, [user, refresh]);

  const links = useMemo(() => {
    const baseLinks = mockdata.map((item) => <LinksGroup {...item} key={item.label} />);

    if (isAdminLocal) {
      baseLinks.push(
        <LinksGroup label="Administration" icon={IconUser} initiallyOpened links={[{ label: 'Gérer les utilisateurs', link: '/manageusers' }]} key="administration" />
      );
    }

    return baseLinks;
  }, [isAdminLocal]);

  return (
    <>
      {userExistLocal && (
        <AppShell.Navbar style={{ display: 'flex', justifyContent: 'space-between' }} p="md">
          <nav className={classes.navbar}>
            <ScrollArea className={classes.links}>
              <div className={classes.linksInner}>{links}</div>
            </ScrollArea>
          </nav>
        </AppShell.Navbar>
      )}
    </>
  );
}
